import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Always reset scroll to top on route change
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      // Ensure document and main element are reset as well
      document.documentElement.scrollTop = 0;
      const main = document.querySelector('main');
      if (main) (main as HTMLElement).scrollTop = 0;
    } catch {
      // Fallback without options
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}